// external scripts
import $ from "jquery";
import debug from 'bows/dist/bows.min.js';
//import fitext from 'fitText';


// Polyfill
import './base/_polyfill';
import 'date-input-polyfill';

// example of ES2015 modules loading & tree shaking
import { emptyLinks } from "./base/_links";
import throttle from './base/_throttle.js';
import size from "./base/_size";
import isTouch from "./base/_isTouch";
import fitvid from "./base/_fitvid";
import keyboardFocus from "./base/_keyboardFocus";
import smoothScroll from "./base/_smoothScroll";
import share from "./base/_share";
import tabs from "./base/_tabs";
import loadScripts from "./base/_loadScripts";
import tracking from "./base/_tracking";
import modal from './base/_modal';
import debugFrontend from "./base/_debugFrontend";
import navigation from './_navigation.js';
// import homeHero from './_home-hero.js';

// Site
import accordion from "./_accordion";
import alert from './_alert';
import editor from "./_editor";
import grid from './_grid';
import filter from './_filter';
import general from './_general';
import customPlayer from './_jwplayer';

//import fitText from './_fitText';
//Slider Imports
import carousel from './sliders/_carousel';
import single from './sliders/_single';
import sliderHelper from './sliders/_slider-helper';
import singleImage from './sliders/_single-image';
import testimonial from './sliders/_testimonial';
import gallery from './sliders/_gallery';
import featured from './sliders/_featured';
import social from './sliders/_social';
import singleSmall from './sliders/_single-small';
// Card Imports
import cards from './_card';
// Education Imports
import education from './_education';
import collection from './sliders/_collection';


const $window = $(window);
const $document = $(document);
const log = debug("site");

class Site {

  constructor() {
    document.addEventListener('DOMContentLoaded', () => this.ready());
    window.addEventListener('load', () => this.load());
    window.addEventListener('resize', throttle(this.resize.bind(this), 25));
    this.resize();
    filter.init(); // Drupal.behaviors initializes on ready
  }

  ready() {
    $('html').removeClass('no-js').addClass('js');
    const log = debug("site:domReady");


    navigation.init();
    tracking.init();

    isTouch.init();
    keyboardFocus.init();
    smoothScroll.init();
    share.init();
    size.init();
    //picturefill();

    //homeHero.init();
    //general.init();
    alert.init();
    accordion.init();
    tabs.init();
    editor.init();
    grid.init();
    modal.init();
    debugFrontend.init();
    general.init();

    // Sliders
    carousel.init();
    single.init();
    collection.init();
    sliderHelper.init();
    singleImage.init();
    testimonial.init();
    gallery.init();
    featured.init();
    social.init();
    singleSmall.init();

    this.customPlayer = new customPlayer();

    //Cards
    cards.init();
    //Education
    education.init();
    log('document.DOMContentLoaded');


    // //datepicker
    // var dateControl = document.querySelector('input[type="date"]');
    // dateControl.value = '2017-06-01';
    // console.log(dateControl.value); // prints "2017-06-01"
    // console.log(dateControl.valueAsNumber); // prints 1496275200000, a JavaScript timestamp (ms)


    window.wdg_pauseOthers = function (id) {
      log('DONT USE');
      // console.log('Playback just started for: ' + id);
      // var videos = document.querySelectorAll('.jwplayer');
      // for (let i = 0; i < videos.length; i++) {
      //   if (id != videos[i].id) {
      //     jwplayer(videos[i].id).pause(true);
      //     console.log('Pausing: ' + videos[i].id);
      //   }
      // }
    }

    fitvid();
  }

  load() {
    const log = debug("site:windowLoad");
    log("window.onload");
    fitvid();

    // example of ES2015 modules loading & tree shaking
    //emptyLinks();
  }

  resize() {

  }

}

export default Site;
